import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactModal from 'react-modal';
import classNames from 'classnames';
import styles from './styles.scss';
import ClickOutside from '../ClickOutside';

export default class Modal extends Component {
  static propTypes = {
    children: PropTypes.node,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    className: PropTypes.string,
    hideCloseBtn: PropTypes.bool,
    disableCloseOnClickOutside: PropTypes.bool,
    disableCloseOnEsc: PropTypes.bool,
  };

  static defaultProps = {
    isOpen: false,
  };

  constructor(props) {
    super(props);
    this.onClickOutside = this.onClickOutside.bind(this);
    this.onESCClose = this.onESCClose.bind(this);
    this.onClose = this.onClose.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.onESCClose);
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.onESCClose);
  }

  onESCClose(e) {
    if (!this.props.disableCloseOnEsc && (e.which === 27 || e.keyCode === 27)) {
      this.props.onClose();
    }
  }

  onClickOutside(event) {
    event.preventDefault();
    if (!this.props.disableCloseOnClickOutside) this.props.onClose();
  }

  onClose(event) {
    event.preventDefault();
    this.props.onClose();
  }

  render() {
    const { className, children, onClose, hideCloseBtn } = this.props;

    return (
      <ReactModal
        {...this.props}
        className={classNames(className, styles.content)}
        closeTimeoutMS={300}
      >
        {!hideCloseBtn && (
          <button
            className={classNames(styles.close, 'react-modal-close-icon')}
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            onClick={this.onClose}
          >
            <span aria-hidden="true" onClick={onClose}>
              ×
            </span>
          </button>
        )}
        <ClickOutside onClickOutside={this.onClickOutside}>{children}</ClickOutside>
      </ReactModal>
    );
  }
}
